import React from 'react';

const Button = ({ 
  children, 
  onClick, 
  disabled = false, 
  variant = 'primary', 
  size = 'medium',
  style = {},
  ...props 
}) => {
  const baseStyle = {
    border: 'none',
    borderRadius: '50px',
    cursor: disabled ? 'not-allowed' : 'pointer',
    transition: 'transform 0.3s ease',
    fontWeight: 'bold',
    ...style
  };

  const variants = {
    primary: {
      background: '#6b7280',
      color: 'white',
    },
    secondary: {
      background: '#f8f9fa',
      color: '#333',
      border: '2px solid #e1e5e9',
    },
    danger: {
      background: '#dc3545',
      color: 'white',
    }
  };

  const sizes = {
    small: {
      padding: '8px 16px',
      fontSize: '0.9rem',
    },
    medium: {
      padding: '15px 30px',
      fontSize: '1.1rem',
    },
    large: {
      padding: '20px 40px',
      fontSize: '1.2rem',
    }
  };

  const disabledStyle = disabled ? {
    opacity: 0.6,
    transform: 'none',
  } : {};

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{
        ...baseStyle,
        ...variants[variant],
        ...sizes[size],
        ...disabledStyle
      }}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
